// @ts-ignore
import React from 'react';

import {Button, Heading, HStack, Text, VStack} from "@chakra-ui/react";
import {Navigate, useNavigate} from "react-router-dom";
import {ContentCard} from "../Components/ContentCard";
import {useAuth} from "../UserManagement/authprovider";

function Homepage() {
    const navigate = useNavigate();
    const {isLoggedIn} = useAuth();

    if (isLoggedIn) {
        return <Navigate to="/account" replace />;
    }

    return (
        <VStack justifyContent="center" alignItems="center" width="100%" height="100%" pb="10px">
            <ContentCard w="100%" textAlign="center">
                <Heading as="h1" size="2xl" fontWeight="bold" lineHeight="1.15" mb={4} color="gray.900">
                    Welcome, Developers
                </Heading>
                <Text fontSize="lg" color="gray.600" maxW="560px" mx="auto" mb={6}>
                    Sign up or sign in to manage API keys for your Eridani-powered apps.
                </Text>
                <HStack justifyContent="center" gap={4}>
                    <Button colorScheme="blue" size="lg" px={8} fontWeight="semibold" onClick={() => navigate("/signup")}>
                        Sign Up
                    </Button>
                    <Button variant="outline" colorScheme="blue" size="lg" px={8} fontWeight="semibold" onClick={() => navigate("/signin")}>
                        Sign In
                    </Button>
                </HStack>
            </ContentCard>
        </VStack>
    );
}

export default Homepage;
